import { Stack, SxProps } from '@mui/material';

import palette from '../theme/palette';

type BetaProps = {
  sx?: SxProps;
  text?: string;
};

const Beta = ({ sx, text }: BetaProps) => (
  <Stack
    sx={{
      backgroundColor: palette.blue[600],
      borderRadius: '4px',
      padding: '4px 8px',
      color: palette.blue[700],
      fontSize: '12px',
      fontWeight: 'bold',
      border: `1px solid ${palette.blue[500]}`,
      ...sx
    }}
  >
    {text || 'Beta'}
  </Stack>
);

export default Beta;
